/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Platform_SupportInputs */

const en_inbox_platform_support = /** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Support`)
};

const es_inbox_platform_support = /** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte de la Plataforma`)
};

const fr_inbox_platform_support = /** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support de la plateforme`)
};

const de_inbox_platform_support = /** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-Support`)
};

const id_inbox_platform_support = /** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Platform`)
};

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const ja_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const zh_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const ar_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const it_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const ru_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const pt_inbox_platform_support = en_inbox_platform_support;

/** @type {(inputs: Inbox_Platform_SupportInputs) => LocalizedString} */
const ko_inbox_platform_support = en_inbox_platform_support;

/**
* | output |
* | --- |
* | "Platform Support" |
*
* @param {Inbox_Platform_SupportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_platform_support = /** @type {((inputs?: Inbox_Platform_SupportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Platform_SupportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_platform_support(inputs)
	if (locale === "es") return es_inbox_platform_support(inputs)
	if (locale === "fr") return fr_inbox_platform_support(inputs)
	if (locale === "de") return de_inbox_platform_support(inputs)
	if (locale === "ja") return ja_inbox_platform_support(inputs)
	if (locale === "zh") return zh_inbox_platform_support(inputs)
	if (locale === "ar") return ar_inbox_platform_support(inputs)
	if (locale === "id") return id_inbox_platform_support(inputs)
	if (locale === "it") return it_inbox_platform_support(inputs)
	if (locale === "ru") return ru_inbox_platform_support(inputs)
	if (locale === "pt") return pt_inbox_platform_support(inputs)
	return ko_inbox_platform_support(inputs)
});